import { render, staticRenderFns } from "./TheThreadEvent.vue?vue&type=template&id=202f1485"
import script from "./TheThreadEvent.vue?vue&type=script&lang=js"
export * from "./TheThreadEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports